import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, catchError } from "rxjs/operators"
import { push } from "connected-react-router"
import { hideLoader } from "../loader/actions"
import {
    fetchSwitchInstructionPatternsFailed,
    setSwitchInstructionPatterns,
    createSwitchInstructionFailue,
    createSwitchInstructionSuccess,
    fetchSwitchRequestsSuccess,
    fetchSwitchRequestsFailure,
} from "./actions"
import { showNotification } from "../notification/actions"
import switchRequestApi from "../../api/switchRequests-api"
import { labels } from "../../constants/labels"

import * as types from "./actionTypes"

export function fetchSwitchInstructionPatterns(action$) {
    return action$.pipe(
        ofType(types.FETCH_SWITCH_INSTRUCTION_PATTERNS),
        switchMap(() =>
            from(switchRequestApi.getSwitchInstructionPatterns()).pipe(
                switchMap((data) => {
                    return of(setSwitchInstructionPatterns(data))
                }),
                catchError((error) =>
                    of(fetchSwitchInstructionPatternsFailed(error))
                )
            )
        )
    )
}

export function createSwitchInstruction(action$) {
    return action$.pipe(
        ofType(types.CREATE_SWITCH_INSTRUCTION),
        switchMap((action) =>
            from(switchRequestApi.createSwitchInstruction(action.payload)).pipe(
                switchMap((reponse) => {
                    return of(
                        createSwitchInstructionSuccess(reponse),
                        showNotification({
                            show: true,
                            message:
                                labels.switchRequestLabels
                                    .switchRequestCreatedSuccessfully,
                            alertType: "success",
                        }),
                        push("/switch-requests")
                    )
                }),
                catchError((error) =>
                    of(
                        createSwitchInstructionFailue(error),
                        showNotification({
                            show: true,
                            message:
                                labels.switchRequestLabels
                                    .switchRequestCreateFailed,
                            alertType: "error",
                        })
                    )
                )
            )
        )
    )
}

export function fetchSwitchRequests(action$) {
    return action$.pipe(
        ofType(types.SWITCH_REQUESTS_FETCH_DATA),
        switchMap((action) =>
            from(
                switchRequestApi.getAllSwitchRequestsData(action.payload)
            ).pipe(
                switchMap((data) =>
                    of(fetchSwitchRequestsSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        fetchSwitchRequestsFailure(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchSwitchRequestsFilter(action$) {
    return action$.pipe(
        ofType(types.SWITCH_REQUESTS_FETCH_FILTER),
        switchMap((action) =>
            from(
                switchRequestApi.getAllSwitchRequestsData(action.payload)
            ).pipe(
                switchMap((data) =>
                    of(fetchSwitchRequestsSuccess(data), hideLoader())
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        fetchSwitchRequestsFailure(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
